import { navigate } from 'hookrouter'
import { useCompany, useUser } from 'hooks/useCompany'
import { APP_ROUTES } from 'pages/AppRouter'
import React, { FC } from 'react'
import { NavDropdown } from 'react-bootstrap'
import { useAppContext } from 'state/context'
import { CompanyIdUrlParam } from 'types'

export const DefaultDropdownText = 'Pick a Company'
export const CreateCompanyText = '+ Create a Company'

export const ActiveCompanyNavSelector: FC<CompanyIdUrlParam> = ({
  companyId
}) => {
  const [{ companies }] = useAppContext()
  const activeCompany = useCompany(companyId)
  const user = useUser();
  
  const navigateToNewCompanyForm = () => navigate(APP_ROUTES.newCompany)

  return (
    <NavDropdown
      title={activeCompany ? activeCompany.name : DefaultDropdownText}
      id="company-nav-dropdown"
      className="company-name">
      {companies
        .filter(company =>
          activeCompany ? activeCompany.id !== company.id : true,
        )
        .map(company => {
          const onSelect = () => navigate(`/company/${company.id}`)
          return (
            <NavDropdown.Item key={company.id} onSelect={onSelect}>
              {company.name}
            </NavDropdown.Item>
          )
        })}
      {(user?.isCompanyManager || user?.isAdmin)  && <NavDropdown.Item onSelect={navigateToNewCompanyForm}>
        {CreateCompanyText}
      </NavDropdown.Item>}
    </NavDropdown>
  )
}
